import { render, staticRenderFns } from "./ManualExitCategory.vue?vue&type=template&id=72c14625&"
import script from "./ManualExitCategory.vue?vue&type=script&lang=js&"
export * from "./ManualExitCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports